import normalize from 'json-api-normalizer';
import Program from './program';

export default class Enrollment {

	static from (jsonapi) {

		let normalizedJSONapi = normalize(jsonapi);

		if (normalizedJSONapi.enrollments) {

			let keys = Object.keys(normalizedJSONapi.enrollments);
			if (keys.length > 0 && Array.isArray(jsonapi.data)) {
				let retVal = {};
				keys.forEach( function ( messageId) {
					let enrol = Enrollment.makeEnrollment(normalizedJSONapi.enrollments[messageId], normalizedJSONapi);
					if (enrol) retVal[messageId] = enrol;
				});
				return retVal;
			} else {
				let enrol = Enrollment.makeEnrollment(normalizedJSONapi.enrollments[keys[0]], normalizedJSONapi);
				return (enrol) ? enrol : {};
			}

		} else return null;
	}

	static makeEnrollment(jsonapi, normalizedJSONapi) {
		const { id, attributes } = jsonapi;

		let relationships = {};

		if (attributes['programId'] && normalizedJSONapi['programs'] && normalizedJSONapi['programs'][attributes['programId']]) {

			relationships['program'] = Program.make(normalizedJSONapi['programs'][attributes['programId']], normalizedJSONapi);

			return new Enrollment( Object.assign({id: id}, attributes, relationships) );
		}

		return false;

	}

	constructor ({ id, programId, program, status, startsAt, endsAt, terminatedAt, firstViewedAt, lastViewedAt, displayName, internalName, state, description,viewCount, forumConsentAt }) {

	  this.id               = id ? id : -1
	  this.program_id       = programId ? programId : -1;
	  this.program          = program ? program : null;
	  this.status           = status ? status : '';
	  this.starts_at        = startsAt ? startsAt : null;
	  this.ends_at          = endsAt ? endsAt : null;
	  this.terminated_at	= terminatedAt ? terminatedAt : null;
		this.first_viewed_at  = firstViewedAt ? firstViewedAt : null;
		this.last_viewed_at   = lastViewedAt ? lastViewedAt : null;
		this.view_count       = viewCount ? viewCount : null;

	  this.display_name     = displayName ? displayName : '';
	  this.internal_name    = internalName ? internalName : '';
	  this.state            = state ? state : '';
	  this.description      = description ? description : null;
	  this.forum_consent_at = forumConsentAt ? forumConsentAt : null; 

	}
}
